module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "image",
    attrs: {
      "id": "image1"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/image-7.jpg"
    }
  })])]), _vm._v(" "), _c('h1', [_vm._v("DEDICATION")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("To the ones who loved me just for being Michael.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And to all who made my journey possible …")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f58872c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004dedication.vue
// module id = 66
// module chunks = 0